<script setup lang="ts">
import { useDark, useWindowSize, useThrottleFn } from '@vueuse/core'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import useAppStore from './stores/modules/app'
import useSettingStore from './stores/modules/setting'
import { ScreenEnum } from './enums/appEnums'
import { enumType } from '@/types/index'
import { verifyToken } from '@/api/index'
import useUserStore from '@/stores/modules/user'
import { clearAuthInfo } from '@/utils/auth'
const appStore = useAppStore()
const userStore = useUserStore()
const settingStore = useSettingStore()
const elConfig = {
    zIndex: 3000,
    locale: zhCn
}
const isDark = useDark()

const verifyTokenFun = () => {
    const params = { token: userStore.token }
    verifyToken(params).then((data) => {
        const { result } = data
        if (!result) {
            clearAuthInfo()
        }
    })
}
verifyTokenFun()

onMounted(async () => {
    //设置主题色
    settingStore.setTheme(isDark.value)
    const data: any = await appStore.recordsConfig()
    // 获取枚举数据
    await appStore.getEnum(enumType.join(','))
    // 获取基础数据
    await appStore.getBaseCode()

    // 获取地址信息
    await appStore.getAddressList()
    // 获取省份信息
    await appStore.getProvinceList()
    // 获取主办单位证件类型
    await appStore.getOrganizerIdType()

    // 获取用户信息
    // await userStore.getUserInfo()

    // 获取ICP配置
    await appStore.getIcpConfig()

    document.dispatchEvent(new Event('render-ready'))
    // 设置网站logo
    let favicon: HTMLLinkElement = document.querySelector('link[rel="icon"]')!
    if (favicon) {
        favicon.href = data.company.web_favicon
        return
    }
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = data.company.web_favicon
    document.head.appendChild(favicon)
})

const { width } = useWindowSize()
watch(
    width,
    useThrottleFn((value) => {
        if (value > ScreenEnum.SM) {
            appStore.setMobile(false)
            appStore.toggleCollapsed(false)
        } else {
            appStore.setMobile(true)
            appStore.toggleCollapsed(true)
        }
        if (value < ScreenEnum.MD) {
            appStore.toggleCollapsed(true)
        }
    }),
    {
        immediate: true
    }
)
</script>

<template>
    <h1 style="position: fixed; left: -99999; top: -99999; opacity: 0">
        ICP备案管理系统
    </h1>
    <el-config-provider :locale="elConfig.locale" :z-index="elConfig.zIndex">
        <router-view />
    </el-config-provider>
</template>

<style lang="scss">
.el-image {
    .el-image-viewer__close {
        background-color: #ff0000;
    }
    .el-image-viewer__next {
        background-color: #4a5dff;
    }
    .el-image-viewer__prev {
        background-color: #4a5dff;
    }
}
.el-radio.el-radio--small {
    margin-right: 20px;
}
.el-card__body {
    padding: 10px !important;
}

.custom-close-verify {
    position: absolute;
    right: -6px;
    top: -6px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: #3441b2;
    text-align: center;
    line-height: 26px;
    color: #fff;
    font-size: 20px;
}
</style>
